import { IntegrationWithJobInfo, getSageLocations } from "@/api/integration"
import { CreditMemoLocationSettings } from "./credit-memo-location-settings"

interface SageLocationSettingsProps {
  integration: IntegrationWithJobInfo
}

/**
 * Lets the user pick the multi-entity location applied to credit-memo (AR adjustment) lines when
 * applying cash. Required by Sage for multi-entity companies; leave unset for single-entity ones.
 */
export function SageLocationSettings({ integration }: SageLocationSettingsProps) {
  return (
    <CreditMemoLocationSettings
      integration={integration}
      description="For multi-entity Sage Intacct companies, credit memos created when applying cash must specify a location. Choose the location to apply."
      none_label="None (single-entity company)"
      fetch_locations={getSageLocations}
    />
  )
}
